import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { useCpFormValue } from "../../gvc/testNewForm/utils";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpSelect } from "../../gvc/testNewForm/CpSelect";
import { CpInputNumber } from "../../gvc/testNewForm/CpInputNumber";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpLabelDirtyIndicator } from "../../gvc/testNewForm/CpLabelDirtyIndicator";
import { Only } from "./only";

interface Props {}
export const WorkloadJob: React.FC<Props> = ({}) => {
  const type = useCpFormValue(`type`);

  if (type !== "cron") {
    return null;
  }

  return (
    <div className="cpln-form-section cpln-form-card cpln-ant-card-container">
      <Card>
        <CardTitle>Job</CardTitle>
        <CardContent>
          <CpFormItem>
            <CpLabel name={`job.schedule`}>
              Schedule
              <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                <CpLabelDirtyIndicator name={`job.schedule`} />
              </Only>
            </CpLabel>
            <CpInput name={`job.schedule`} style={{ width: 600 }} />
            <CpErrorWarning name={`job.schedule`} />
          </CpFormItem>

          <CpFormItem>
            <div className="flex gap-2" style={{ width: 600 }}>
              <div className="flex flex-col flex-grow basis-0">
                <CpLabel name={`job.concurrencyPolicy`}>
                  Concurrency Policy
                  <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                    <CpLabelDirtyIndicator name={`job.concurrencyPolicy`} />
                  </Only>
                </CpLabel>
                <CpSelect
                  name={`job.concurrencyPolicy`}
                  options={[
                    { label: "Forbid", value: "Forbid" },
                    { label: "Replace", value: "Replace" },
                    { label: "Allow", value: "Allow" },
                  ]}
                />
              </div>
              <div className="flex flex-col flex-grow basis-0">
                <CpLabel name={`job.restartPolicy`}>
                  Restart Policy
                  <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                    <CpLabelDirtyIndicator name={`job.restartPolicy`} />
                  </Only>
                </CpLabel>
                <CpSelect
                  name={`job.restartPolicy`}
                  options={[
                    { label: "OnFailure", value: "OnFailure" },
                    { label: "Never", value: "Never" },
                  ]}
                />
              </div>
            </div>
            <CpErrorWarning name={``} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`job.historyLimit`}>
              History Limit
              <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                <CpLabelDirtyIndicator name={`job.historyLimit`} />
              </Only>
            </CpLabel>
            <CpInputNumber name={`job.historyLimit`} />
            <CpErrorWarning name={`job.historyLimit`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`job.activeDeadlineSeconds`}>
              Active Deadline Seconds
              <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                <CpLabelDirtyIndicator name={`job.activeDeadlineSeconds`} />
              </Only>
            </CpLabel>
            <CpInputNumber name={`job.activeDeadlineSeconds`} />
            <CpErrorWarning name={`job.activeDeadlineSeconds`} />
          </CpFormItem>
        </CardContent>
      </Card>
    </div>
  );
};
